export const ENV = {
  LOCAL: "local",
  STAGING: "staging",
  production: "production",
};
